import { applyMiddleware, createStore } from "redux";
import rootReducer from "./reducer/rootReducer";
import logger from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware()));
export default store;
